
const myDiv = document.getElementById('myDiv');
myDiv.addEventListener('mousemove', function (event) {
  const rect = myDiv.getBoundingClientRect();
  const imgright = document.querySelector('#imgright');
  const imgleft = document.querySelector('#imgleft');

  const min = 0;
  const max = 20;
  const mouseX = event.clientX - rect.left;
  const mouseY = event.clientY - rect.top;
  const nmouseX = (mouseX - min) / (max - min);
  const nmouseY = (mouseY - min) / (max - min);

  imgright.style.setProperty('--mouseX', -nmouseX + 'px');
  imgright.style.setProperty('--mouseY', nmouseY + 'px');

  imgleft.style.setProperty('--mouseX', nmouseX + 'px');
  imgleft.style.setProperty('--mouseY', -nmouseY + 'px');
});
const DivBrands = document.getElementById('DivBrands');
DivBrands.addEventListener('mousemove', function (event) {
  const rect = DivBrands.getBoundingClientRect();

  const imgright = document.querySelector('#img-right');
  const imgleft = document.querySelector('#img-left');

  const min = 0;
  const max = 15;
  const mouseX = event.clientX - rect.left;
  const mouseY = event.clientY - rect.top;
  const nmouseX = (mouseX - min) / (max - min);
  const nmouseY = (mouseY - min) / (max - min);



  imgright.style.setProperty('--mouseX', nmouseX + 'px');
  imgright.style.setProperty('--mouseY', nmouseY + 'px');

  imgleft.style.setProperty('--mouseX', nmouseX + 'px');
  imgleft.style.setProperty('--mouseY', nmouseY + 'px');
});



// -----scroll product 
const slider = document.querySelector('.grid_product  ');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3;
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});




/// Move down button
$(document).ready(function () {
  $("#move-down").on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: $('#about-terme').offset().top - 120 }, '300');
  });

})
